var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66934 21.8287C11.3475 23.1509 13.7398 23.0935 15.3537 21.6924C19.6153 17.9961 24.1924 11.9407 24.1701 7.37988C24.1594 5.30954 22.9414 3.27816 20.9921 2.07955C19.0793 0.904078 17.0221 0.835386 15.1948 1.8865C13.7848 2.69654 12.6955 4.07606 12.1263 5.65716C11.4819 4.10517 10.3278 2.77946 8.88058 2.03794C8.03696 1.60505 7.15781 1.40107 6.27707 1.42219C5.19938 1.44804 4.1188 1.81205 3.09921 2.5087C1.20961 3.79938 0.0903405 5.88682 0.178962 7.95529C0.374274 12.5119 5.23644 18.341 9.67034 21.8287L9.66934 21.8287ZM3.66217 3.33444C5.19645 2.28535 6.88747 2.14076 8.4228 2.92818C10.2933 3.8866 11.6357 6.09505 11.6885 8.29742C11.6951 8.57334 11.9244 8.7919 12.2003 8.78528C12.4762 8.77867 12.6948 8.54936 12.6882 8.27344C12.6353 6.07007 13.8703 3.80081 15.6927 2.75381C17.1895 1.89368 18.8866 1.959 20.4673 2.93138C22.1263 3.9509 23.1615 5.65757 23.1699 7.38586C23.1917 11.6306 18.7945 17.3866 14.6994 20.9379C13.4461 22.0252 11.5927 22.0697 10.2887 21.0436C6.02812 17.6928 1.36 12.1552 1.17827 7.91431C1.10384 6.1876 2.05605 4.43327 3.66419 3.33539L3.66217 3.33444Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24.5685 23.9931) rotate(178.626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.488102acdb072e1f57e7a0a6a6f45fb1.svg";
export { ForwardRef as ReactComponent };